import React from 'react'

export default function Grades() {
    return (
        <div>
            THis is Grades part of quick info
        </div>
    )
}
